/* eslint-disable import/no-cycle */
import { ItemDelegate } from '@leverege/molten-core';
import { GlobalState } from '@leverege/ui-redux';
import ImagineRsrcGroupDelegate from "./ImagineRsrcGroupDelegate.js";
export default class ImagineRsrcItemDelegate extends ItemDelegate {
  constructor(options) {
    super(options);
    this.id = encodeURIComponent(this.id);
    this.resourceApi = this.parent()?.resourceApi?.rsrc(this.path);
    this.queryName = options.queryName;
  }
  toObjectRef(item) {
    if (!item) {
      return null;
    }
    return {
      id: item.id,
      ref: this.relationship.ref,
      type: this.relationship.objectType,
      data: item
    };
  }
  get path() {
    return decodeURIComponent(this.id);
  }
  get(options) {
    const {
      queryName,
      ...rest
    } = options || {};
    const api = this.resourceApi;
    return api.get(rest, {
      queryName: queryName || this.queryName
    });
  }
  getItem(state = GlobalState.get(), useObjectRef = false) {
    const api = this.resourceApi;
    const rsrc = api.getRsrc(state, {
      queryName: this.queryName
    });
    return useObjectRef ? this.toObjectRef(rsrc) : rsrc;
  }
  canDelete() {
    return true;
  }
  canUpdate() {
    return false;
  }
  parent() {
    const {
      parent
    } = this.relationship;
    if (parent == null) {
      return null;
    }
    // if parent is an item or an alias, use ItemDelegate
    if (parent.isItem || parent.isAlias) {
      return new ImagineRsrcItemDelegate({
        relationship: parent,
        // .createResolved( this.match ), 
        match: this.match,
        ...this.options
      });
    }
    return new ImagineRsrcGroupDelegate({
      relationship: parent,
      // .createResolved( this.match ), 
      match: this.match,
      ...this.options
    });
  }
  delete(options) {
    const {
      queryName,
      ...rest
    } = options || {};
    return this.resourceApi.delete(rest, {
      queryName: queryName || this.queryName
    });
  }
  list(options) {
    const {
      queryName,
      ...rest
    } = options || {};
    return this.resourceApi.list(rest, {
      queryName: queryName || this.queryName
    });
  }
  update(data, image, opts) {
    const {
      queryName
    } = opts || {};
    return this.resourceApi.update(data, image, {
      queryName: queryName || this.queryName
    });
  }
}